// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caglik-report .container-fluid {
  max-width: 1400px;
  margin: 0 auto;
}
.caglik-report .page-header .page-title {
  font-size: 2rem;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}
.caglik-report .page-header .page-title i {
  color: #764ba2;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}
.caglik-report .page-header .page-subtitle {
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 0;
  color: #6c757d;
}
.caglik-report .form-label-required {
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}
.caglik-report .form-label-required::after {
  content: " *";
  color: #ef4444;
}
.caglik-report .card {
  border: none;
  border-radius: 16px;
  transition: all 0.3s ease;
  overflow: visible;
}
.caglik-report .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
}
.caglik-report .card.selection-card {
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(102, 126, 234, 0.1);
}
[data-coreui-theme=dark] .caglik-report .card.selection-card {
  background: rgba(33, 37, 41, 0.95);
  border-color: rgba(102, 126, 234, 0.2);
}
.caglik-report .card.details-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(102, 126, 234, 0.1);
}
[data-coreui-theme=dark] .caglik-report .card.details-card {
  background: rgba(33, 37, 41, 0.98);
}
.caglik-report .card .card-header {
  border-radius: 16px 16px 0 0 !important;
  padding: 1.5rem 2rem;
  border-bottom: none;
  position: relative;
}
.caglik-report .card .card-header.gradient-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}
.caglik-report .card .card-header.gradient-header::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%);
}
.caglik-report .card .card-header.gradient-header h5 {
  margin: 0;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.caglik-report .card .card-header.details-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  color: #374151;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
}
.caglik-report .card .card-header.details-header .details-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.caglik-report .card .card-header.details-header .details-title {
  font-weight: 600;
  color: #667eea;
  margin-bottom: 0.5rem;
}
.caglik-report .card .card-header.details-header .details-title i {
  color: #764ba2;
}
.caglik-report .card .card-header.details-header .details-badges {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.caglik-report .card .card-body {
  border-radius: 0 0 16px 16px;
  padding: 2rem;
}
.caglik-report .action-buttons-group {
  display: flex;
  gap: 12px;
  width: 100%;
}
.caglik-report .action-buttons-group .btn-report-generate {
  flex: 1 1;
  padding: 12px 24px;
  font-weight: 600;
  border-radius: 12px;
  font-size: 0.95rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}
.caglik-report .action-buttons-group .btn-report-generate:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
  background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
}
.caglik-report .action-buttons-group .btn-report-generate:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.caglik-report .action-buttons-group .btn-report-generate i {
  margin-right: 8px;
}
.caglik-report .action-buttons-group .btn-clear {
  padding: 12px 20px;
  font-weight: 600;
  border-radius: 12px;
  font-size: 0.95rem;
  background: transparent;
  border: 2px solid #e5e7eb;
  color: #6b7280;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}
.caglik-report .action-buttons-group .btn-clear:hover:not(:disabled) {
  border-color: #ef4444;
  color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}
.caglik-report .action-buttons-group .btn-clear:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.caglik-report .action-buttons-group .btn-clear .clear-icon {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
}
.caglik-report .action-buttons-export {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.caglik-report .action-buttons-export .btn-action-print,
.caglik-report .action-buttons-export .btn-action-excel {
  border-radius: 10px;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 2px solid transparent;
}
.caglik-report .action-buttons-export .btn-action-print::before,
.caglik-report .action-buttons-export .btn-action-excel::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s ease;
}
.caglik-report .action-buttons-export .btn-action-print:hover::before,
.caglik-report .action-buttons-export .btn-action-excel:hover::before {
  width: 200px;
  height: 200px;
}
.caglik-report .action-buttons-export .btn-action-print .btn-text,
.caglik-report .action-buttons-export .btn-action-excel .btn-text {
  position: relative;
  z-index: 2;
}
.caglik-report .action-buttons-export .btn-action-print i,
.caglik-report .action-buttons-export .btn-action-excel i {
  position: relative;
  z-index: 2;
}
.caglik-report .action-buttons-export .btn-action-print {
  background: rgba(108, 117, 125, 0.1);
  border-color: rgba(108, 117, 125, 0.2);
  color: #6c757d;
}
.caglik-report .action-buttons-export .btn-action-print:hover {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  border-color: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.4);
}
.caglik-report .action-buttons-export .btn-action-excel {
  background: rgba(25, 135, 84, 0.1);
  border-color: rgba(25, 135, 84, 0.2);
  color: #198754;
}
.caglik-report .action-buttons-export .btn-action-excel:hover {
  background: linear-gradient(135deg, #198754 0%, #157347 100%);
  border-color: #198754;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(25, 135, 84, 0.4);
}
.caglik-report .detail-badge {
  font-weight: 500;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
.caglik-report .detail-badge:hover {
  transform: scale(1.05);
}
.caglik-report .detail-badge.code-badge {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  border-color: #f093fb;
}
.caglik-report .detail-badge.type-badge {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  border-color: #4facfe;
}
.caglik-report .detail-badge.date-badge {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
  border-color: #43e97b;
}
.caglik-report .alert {
  border: none;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.caglik-report .alert.alert-danger {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  border-left: 4px solid #dc3545;
}
[data-coreui-theme=dark] .caglik-report .alert.alert-danger {
  background: rgba(220, 53, 69, 0.15);
  color: #f8d7da;
}
.caglik-report .alert i {
  margin-right: 0.5rem;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}
.caglik-report .report-a4-preview {
  display: block;
  overflow-x: auto;
  overflow-y: visible;
  padding: 1.5rem;
  background: #ffffff;
  max-height: none;
}
.caglik-report .report-a4-preview > * {
  width: 100%;
  min-width: 100%;
  min-height: auto !important;
  height: auto !important;
}
.caglik-report .report-preview-card .report-a4-preview {
  padding: 1.5rem;
  background: #ffffff;
}
.caglik-report .report-preview-card .report-a4-preview > * {
  min-height: auto !important;
  height: auto !important;
  padding: 0 !important;
}
.caglik-report .report-page-break {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 3px dashed #ccc;
}

.report-a4-preview {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 2rem;
  border-radius: 16px;
}
.report-a4-preview > * {
  width: 210mm;
  min-height: 297mm;
  margin: 0 auto;
  background: white;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 20px 40px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.05);
  padding: 12mm;
  border-radius: 8px;
  position: relative;
}
.report-a4-preview > *::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px 8px 0 0;
  opacity: 0.3;
}

.report-preview-card {
  border: none !important;
  border-radius: 16px !important;
  overflow: visible;
  background: #ffffff;
  backdrop-filter: blur(20px);
}
.report-preview-card .card-body {
  padding: 0 !important;
  overflow: visible;
}
.report-preview-card .report-wrap {
  width: 100%;
}
.report-preview-card .page-meta-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
}
.report-preview-card .page-meta-left {
  flex: 1 1;
  display: flex;
  align-items: center;
  min-height: 34px;
}
.report-preview-card .page-meta-spacer {
  width: 1px;
  height: 1px;
}
.report-preview-card .tip-code-box {
  display: inline-flex;
  align-items: center;
  border: 2px solid #000;
  background: #fff;
  min-height: 34px;
}
.report-preview-card .tip-code-box .tip-label {
  font-weight: 700;
  background: #f0f0f0;
  border-right: 2px solid #000;
  padding: 8px 10px;
  white-space: nowrap;
  color: #000;
  font-size: 13px;
  line-height: 1;
}
.report-preview-card .tip-code-box .tip-value {
  font-weight: 600;
  padding: 8px 12px;
  min-width: 120px;
  color: #000;
  font-size: 13px;
  line-height: 1;
}
.report-preview-card .page-number-box {
  margin-left: auto;
  border: 2px solid #000;
  background: #fff;
  color: #000;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  padding: 7px 12px;
}
.report-preview-card .header-table {
  width: 100% !important;
  border-collapse: collapse;
  font-size: 14px;
  margin-bottom: 8px;
  border: 2px solid #000;
  table-layout: fixed;
}
.report-preview-card .header-table td {
  border: 1px solid #000;
  padding: 6px 10px;
  vertical-align: middle;
}
.report-preview-card .header-table .label-cell {
  font-weight: 700;
  background: #f5f5f5;
  white-space: nowrap;
  color: #000;
}
.report-preview-card .header-table .value-cell {
  background: #ffffff;
  color: #000;
}
.report-preview-card .header-table .photo-area {
  text-align: center;
  vertical-align: middle;
  background: #ffffff;
  padding: 8px 10px;
}
.report-preview-card .header-table .photo-area .weave-photo {
  max-height: 110px;
  max-width: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
.report-preview-card .header-table .photo-area .weave-photo-placeholder {
  font-size: 12px;
  font-weight: 600;
  color: #555;
}
.report-preview-card .header-table .brand-area,
.report-preview-card .header-table .logo-area {
  text-align: center;
  vertical-align: middle;
  background: #ffffff;
  padding: 8px 10px;
}
.report-preview-card .header-table .brand-area img,
.report-preview-card .header-table .logo-area img {
  max-height: 36px;
  max-width: 90px;
  object-fit: contain;
}
.report-preview-card .header-table .company-name {
  font-size: 12px;
  font-weight: 600;
  margin-top: 4px;
  color: #000;
}
.report-preview-card .header-table .report-main-title {
  font-size: 14px;
  font-weight: 700;
  margin-top: 4px;
  color: #000;
}
.report-preview-card .color-report-section {
  margin: 12px 0;
}
.report-preview-card .color-report-title {
  font-size: 15px;
  font-weight: 700;
  padding: 6px 10px;
}
.report-preview-card .color-report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
  border: 2px solid #000;
}
.report-preview-card .color-report-table th,
.report-preview-card .color-report-table td {
  border: 1px solid #000;
  padding: 4px 6px;
  text-align: center;
  background: #ffffff;
  white-space: nowrap;
}
.report-preview-card .color-report-table th {
  background: #f0f0f0;
  font-weight: 600;
  color: #000;
}
.report-preview-card .color-report-table .yarn-name {
  font-size: 13px !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.report-preview-card .color-report-table .yarn-code {
  font-size: 13px !important;
}
.report-preview-card .color-report-table .color-name {
  font-size: 13px !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.report-preview-card .color-report-table .color-code {
  font-size: 13px !important;
}
.report-preview-card .color-report-table .position-col {
  min-width: 26px;
  font-size: 13px;
}
.report-preview-card .color-report-table .total-col {
  background: #e9ecef;
  font-weight: 600;
  font-size: 13px;
}
.report-preview-card .color-report-table .percentage-col {
  background: #e9ecef;
  font-weight: 600;
  font-size: 13px;
}
.report-preview-card .color-report-table .weight-col {
  background: #e9ecef;
  font-size: 13px !important;
}
.report-preview-card .report-a4-preview {
  background: #ffffff;
  padding: 1.5rem;
  border-radius: 0 0 16px 16px;
  overflow-x: auto;
}
.report-preview-card .report-a4-preview > * {
  box-shadow: none;
  border-radius: 0;
  min-height: auto !important;
  height: auto !important;
  width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}
.report-preview-card .report-a4-preview > *::before {
  display: none;
}
.report-preview-card .photo-page-section {
  border: none;
  padding: 0;
  background: #fff;
  min-height: 680px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 10px;
}
.report-preview-card .photo-page-left {
  width: 28%;
  max-width: 28%;
  min-height: 680px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.report-preview-card .photo-page-right {
  width: 72%;
  max-width: 72%;
  min-height: 680px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.report-preview-card .photo-page-frame {
  border: none;
  min-height: 680px;
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: #fff;
}
.report-preview-card .report-photo-large {
  width: 100%;
  max-width: 100%;
  max-height: 680px;
  object-fit: contain;
  display: block;
}

@media (max-width: 768px) {
  .caglik-report .container-fluid {
    padding: 0 1rem;
  }
  .caglik-report .page-header .page-title {
    font-size: 1.5rem;
    flex-direction: column;
    align-items: flex-start;
  }
  .caglik-report .page-header .page-title i {
    margin-bottom: 0.25rem;
    margin-right: 0;
  }
  .caglik-report .action-buttons-group {
    flex-direction: column;
  }
  .caglik-report .action-buttons-group .btn-report-generate {
    width: 100%;
    margin-bottom: 0.5rem;
  }
  .caglik-report .action-buttons-group .btn-clear {
    width: 100%;
    justify-content: center;
  }
  .caglik-report .action-buttons-export {
    flex-direction: column;
    width: 100%;
  }
  .caglik-report .action-buttons-export .btn-action-print,
  .caglik-report .action-buttons-export .btn-action-excel {
    width: 100%;
    justify-content: center;
  }
  .caglik-report .details-header-content {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 1rem;
  }
  .caglik-report .details-badges {
    width: 100%;
  }
  .caglik-report .action-buttons-export {
    width: 100%;
  }
  .caglik-report .report-a4-preview {
    padding: 1rem;
  }
  .caglik-report .report-a4-preview > * {
    width: 100%;
    min-height: auto;
    padding: 8mm;
  }
}
@media (max-width: 576px) {
  .caglik-report .details-badges .detail-badge {
    font-size: 0.75rem;
    padding: 0.375rem 0.625rem;
  }
  .caglik-report .action-buttons-export .btn-action-print .btn-text,
  .caglik-report .action-buttons-export .btn-action-excel .btn-text {
    display: none;
  }
}
@media print {
  .caglik-report .page-header,
  .caglik-report .card:not(.report-preview-card),
  .caglik-report .alert {
    display: none !important;
  }
  .report-a4-preview {
    padding: 0 !important;
    background: none !important;
    border-radius: 0 !important;
    min-height: auto !important;
  }
  .report-a4-preview > * {
    width: 100% !important;
    min-height: auto !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 5mm !important;
    border-radius: 0 !important;
    transform: none !important;
  }
  .report-a4-preview > *::before {
    display: none !important;
  }
}
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.report-preview-card {
  animation: slideInUp 0.5s ease-out;
}

.btn:focus,
.form-control:focus,
.form-select:focus {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15) !important;
  border-color: #667eea !important;
  outline: none;
}

.card:hover .details-header {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%) !important;
}

.detail-badge:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease;
}

[data-coreui-theme=dark] .caglik-report .page-title {
  color: #8da3f0;
}
[data-coreui-theme=dark] .caglik-report .page-subtitle {
  color: #9ca3af;
}
[data-coreui-theme=dark] .caglik-report .report-a4-preview {
  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
}
[data-coreui-theme=dark] .caglik-report .selection-card,
[data-coreui-theme=dark] .caglik-report .details-card {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;
}

[data-coreui-theme=dark] .caglik-report {
  color: #e5e7eb;
}
[data-coreui-theme=dark] .caglik-report .form-label-required,
[data-coreui-theme=dark] .caglik-report .page-subtitle,
[data-coreui-theme=dark] .caglik-report label,
[data-coreui-theme=dark] .caglik-report small {
  color: #e5e7eb;
}
[data-coreui-theme=dark] .caglik-report .card.selection-card,
[data-coreui-theme=dark] .caglik-report .card.details-card {
  background: rgba(17, 24, 39, 0.95);
  color: #e5e7eb;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
[data-coreui-theme=dark] .caglik-report .details-card .details-header {
  background: linear-gradient(135deg, #111827 0%, #1f2937 100%) !important;
  color: #e5e7eb;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
[data-coreui-theme=dark] .caglik-report input.form-control,
[data-coreui-theme=dark] .caglik-report .form-select {
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: #374151 !important;
}
[data-coreui-theme=dark] .caglik-report input.form-control::placeholder {
  color: #9ca3af;
}
[data-coreui-theme=dark] .caglik-report .alert.alert-danger {
  background: rgba(185, 28, 28, 0.15);
  color: #fecaca;
  border-left: 4px solid #ef4444;
}
[data-coreui-theme=dark] .caglik-report .btn-report-generate {
  color: #ffffff;
}
[data-coreui-theme=dark] .caglik-report .btn-clear {
  color: #9ca3af;
  border-color: #374151;
}
[data-coreui-theme=dark] .caglik-report .btn-clear:hover {
  color: #f87171;
  border-color: #ef4444;
}

.cursor-pointer {
  cursor: pointer !important;
}

.glassmorphism {
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.gradient-text {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.fade-in-up {
  animation: fadeInUp 0.5s ease forwards;
}

.color-report-table {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
}
.color-report-table th,
.color-report-table td {
  border: 1px solid #dee2e6;
  padding: 0.5rem;
  text-align: center;
  font-size: 0.875rem;
}
.color-report-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #495057;
}
.color-report-table .color-name {
  width: 150px;
  text-align: left;
  font-weight: 500;
}
.color-report-table .color-number {
  width: 120px;
  text-align: left;
  font-weight: 500;
}
.color-report-table .position-col {
  width: 50px;
  min-width: 50px;
}
.color-report-table .total-col {
  width: 80px;
  text-align: center;
  font-weight: 600;
  background: #e9ecef;
}
.color-report-table .percentage-col {
  width: 60px;
  text-align: center;
  font-weight: 600;
}
.color-report-table .weight-col {
  width: 80px;
  text-align: center;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/CaglikReport/CaglikReport.scss"],"names":[],"mappings":"AAIE;EACE,iBAAA;EACA,cAAA;AAHJ;AAOI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AALN;AAOM;EACE,cAAA;EACA,iDAAA;AALR;AASI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAPN;AAWE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AATJ;AAWI;EACE,aAAA;EACA,cAAA;AATN;AAcE;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AAZJ;AAcI;EACE,2BAAA;EACA,sDAAA;AAZN;AAeI;EACE,2BAAA;EACA,qCAAA;EACA,0CAAA;AAbN;AAeM;EACE,kCAAA;EACA,sCAAA;AAbR;AAiBI;EACE,qCAAA;EACA,2BAAA;EACA,0CAAA;AAfN;AAiBM;EACE,kCAAA;AAfR;AAmBI;EACE,uCAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AAjBN;AAmBM;EACE,wEAAA;EACA,uBAAA;AAjBR;AAmBQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kGAAA;AAjBV;AAuBQ;EACE,SAAA;EACA,gBAAA;EACA,yCAAA;AArBV;AAyBM;EACE,6DAAA;EACA,cAAA;EACA,iDAAA;AAvBR;AAyBQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAvBV;AA0BQ;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAxBV;AA0BU;EACE,cAAA;AAxBZ;AA4BQ;EACE,aAAA;EACA,YAAA;EACA,eAAA;AA1BV;AA+BI;EACE,4BAAA;EACA,aAAA;AA7BN;AAkCE;EACE,aAAA;EACA,SAAA;EACA,WAAA;AAhCJ;AAkCI;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,yBAAA;AAhCN;AAkCM;EACE,2BAAA;EACA,+CAAA;EACA,6DAAA;AAhCR;AAmCM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAjCR;AAoCM;EACE,iBAAA;AAlCR;AAsCI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AApCN;AAsCM;EACE,qBAAA;EACA,cAAA;EACA,mCAAA;AApCR;AAuCM;EACE,YAAA;EACA,mBAAA;AArCR;AAwCM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAtCR;AA2CE;EACE,aAAA;EACA,YAAA;EACA,eAAA;AAzCJ;AA2CI;;EAEE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;AAzCN;AA2CM;;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;AAxCR;AA2CM;;EACE,YAAA;EACA,aAAA;AAxCR;AA2CM;;EACE,kBAAA;EACA,UAAA;AAxCR;AA2CM;;EACE,kBAAA;EACA,UAAA;AAxCR;AA4CI;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AA1CN;AA4CM;EACE,6DAAA;EACA,qBAAA;EACA,YAAA;EACA,2BAAA;EACA,+CAAA;AA1CR;AA8CI;EACE,kCAAA;EACA,oCAAA;EACA,cAAA;AA5CN;AA8CM;EACE,6DAAA;EACA,qBAAA;EACA,YAAA;EACA,2BAAA;EACA,6CAAA;AA5CR;AAkDE;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;AAhDJ;AAkDI;EACE,sBAAA;AAhDN;AAmDI;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;AAjDN;AAoDI;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;AAlDN;AAqDI;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;AAnDN;AAwDE;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yCAAA;AAtDJ;AAwDI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAtDN;AAwDM;EACE,mCAAA;EACA,cAAA;AAtDR;AA0DI;EACE,oBAAA;EACA,iDAAA;AAxDN;AA6DE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AA3DJ;AA6DI;EACE,WAAA;EACA,eAAA;EACA,2BAAA;EACA,uBAAA;AA3DN;AA+DE;EACE,eAAA;EACA,mBAAA;AA7DJ;AA+DI;EACE,2BAAA;EACA,uBAAA;EACA,qBAAA;AA7DN;AAkEE;EACE,gBAAA;EACA,iBAAA;EACA,2BAAA;AAhEJ;;AAqEA;EACE,6DAAA;EACA,aAAA;EACA,mBAAA;AAlEF;AAoEE;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,wGACE;EAGF,aAAA;EACA,kBAAA;EACA,kBAAA;AArEJ;AAwEI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;EACA,0BAAA;EACA,YAAA;AAtEN;;AA4EA;EACE,uBAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;AAzEF;AA2EE;EACE,qBAAA;EACA,iBAAA;AAzEJ;AA4EE;EACE,WAAA;AA1EJ;AA6EE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;AA3EJ;AA8EE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA5EJ;AA+EE;EACE,UAAA;EACA,WAAA;AA7EJ;AAgFE;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AA9EJ;AAgFI;EACE,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA9EN;AAiFI;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA/EN;AAmFE;EACE,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAjFJ;AAqFE;EACE,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AAnFJ;AAqFI;EACE,sBAAA;EACA,iBAAA;EACA,sBAAA;AAnFN;AAsFI;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AApFN;AAuFI;EACE,mBAAA;EACA,WAAA;AArFN;AAwFI;EACE,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAtFN;AAwFM;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAtFR;AAyFM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAvFR;AA2FI;;EAEE,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAzFN;AA2FM;;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAxFR;AA4FI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA1FN;AA6FI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA3FN;AAgGE;EACE,cAAA;AA9FJ;AAiGE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA/FJ;AAkGE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAhGJ;AAkGI;;EAEE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAhGN;AAmGI;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AAjGN;AAoGI;EACE,0BAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;AAlGN;AAqGI;EACE,0BAAA;AAnGN;AAsGI;EACE,0BAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;AApGN;AAuGI;EACE,0BAAA;AArGN;AAwGI;EACE,eAAA;EACA,eAAA;AAtGN;AAyGI;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AAvGN;AA0GI;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AAxGN;AA2GI;EACE,mBAAA;EACA,0BAAA;AAzGN;AA6GE;EACE,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;AA3GJ;AA6GI;EACE,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;AA3GN;AA6GM;EACE,aAAA;AA3GR;AAiHE;EACE,YAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;AA/GJ;AAkHE;EACE,UAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhHJ;AAmHE;EACE,UAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAjHJ;AAoHE;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAlHJ;AAqHE;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAnHJ;;AAwHA;EAEI;IACE,eAAA;EAtHJ;EA0HI;IACE,iBAAA;IACA,sBAAA;IACA,uBAAA;EAxHN;EA0HM;IACE,sBAAA;IACA,eAAA;EAxHR;EA6HE;IACE,sBAAA;EA3HJ;EA6HI;IACE,WAAA;IACA,qBAAA;EA3HN;EA8HI;IACE,WAAA;IACA,uBAAA;EA5HN;EAgIE;IACE,sBAAA;IACA,WAAA;EA9HJ;EAgII;;IAEE,WAAA;IACA,uBAAA;EA9HN;EAkIE;IACE,iCAAA;IACA,kCAAA;IACA,SAAA;EAhIJ;EAmIE;IACE,WAAA;EAjIJ;EAoIE;IACE,WAAA;EAlIJ;EAqIE;IACE,aAAA;EAnIJ;EAqII;IACE,WAAA;IACA,gBAAA;IACA,YAAA;EAnIN;AACF;AAwIA;EAGM;IACE,kBAAA;IACA,0BAAA;EAxIN;EAgJM;;IACE,aAAA;EA7IR;AACF;AAoJA;EAGI;;;IAGE,wBAAA;EApJJ;EAwJA;IACE,qBAAA;IACA,2BAAA;IACA,2BAAA;IACA,2BAAA;EAtJF;EAwJE;IACE,sBAAA;IACA,2BAAA;IACA,2BAAA;IACA,oBAAA;IACA,uBAAA;IACA,2BAAA;IACA,0BAAA;EAtJJ;EAwJI;IACE,wBAAA;EAtJN;AACF;AA4JA;EACE,WAAA;EACA,YAAA;EACA,kCAAA;AA1JF;;AA6JA;EACE;IACE,uBAAA;EA1JF;EA6JA;IACE,yBAAA;EA3JF;AACF;AA+JA;EACE;IACE,UAAA;IACA,2BAAA;EA7JF;EAgKA;IACE,UAAA;IACA,wBAAA;EA9JF;AACF;AAiKA;EACE;IACE,4BAAA;EA/JF;EAkKA;IACE,2BAAA;EAhKF;AACF;AAmKA;EACE;IACE,UAAA;IACA,2BAAA;EAjKF;EAoKA;IACE,UAAA;IACA,wBAAA;EAlKF;AACF;AAqKA;EACE,kCAAA;AAnKF;;AAuKA;;;EAGE,0DAAA;EACA,gCAAA;EACA,aAAA;AApKF;;AAwKA;EACE,wEAAA;AArKF;;AAwKA;EACE,sBAAA;EACA,+BAAA;AArKF;;AA2KI;EACE,cAAA;AAxKN;AA2KI;EACE,cAAA;AAzKN;AA4KI;EACE,6DAAA;AA1KN;AA6KI;;EAEE,qDAAA;AA3KN;;AAiLA;EAEE,cAAA;AA/KF;AAkLE;;;;EAIE,cAAA;AAhLJ;AAoLE;;EAEE,kCAAA;EACA,cAAA;EACA,2CAAA;AAlLJ;AAsLE;EACE,wEAAA;EACA,cAAA;EACA,kDAAA;AApLJ;AAwLE;;EAEE,oCAAA;EACA,yBAAA;EACA,gCAAA;AAtLJ;AAyLE;EACE,cAAA;AAvLJ;AA2LE;EACE,mCAAA;EACA,cAAA;EACA,8BAAA;AAzLJ;AA6LE;EACE,cAAA;AA3LJ;AA8LE;EACE,cAAA;EACA,qBAAA;AA5LJ;AA+LE;EACE,cAAA;EACA,qBAAA;AA7LJ;;AAkMA;EACE,0BAAA;AA/LF;;AAkMA;EACE,2BAAA;EACA,oCAAA;EACA,0CAAA;AA/LF;;AAkMA;EACE,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AA/LF;;AAkMA;EACE,sCAAA;AA/LF;;AAmMA;EACE,WAAA;EACA,yBAAA;EACA,cAAA;AAhMF;AAkME;;EAEE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAhMJ;AAmME;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAjMJ;AAoME;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAlMJ;AAqME;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAnMJ;AAsME;EACE,WAAA;EACA,eAAA;AApMJ;AAuME;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AArMJ;AAwME;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AAtMJ;AAyME;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AAvMJ","sourcesContent":["// Caglik Report Styles - Modern Design Inspired by CustomerAgreementReport\n.caglik-report {\n\n  // Container padding fix\n  .container-fluid {\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n\n  .page-header {\n    .page-title {\n      font-size: 2rem;\n      font-weight: 600;\n      color: #667eea;\n      margin-bottom: 0.5rem;\n      display: flex;\n      align-items: center;\n\n      i {\n        color: #764ba2;\n        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n      }\n    }\n\n    .page-subtitle {\n      font-size: 1rem;\n      line-height: 1.5;\n      margin-bottom: 0;\n      color: #6c757d;\n    }\n  }\n\n  .form-label-required {\n    font-weight: 500;\n    color: #374151;\n    margin-bottom: 0.5rem;\n\n    &::after {\n      content: ' *';\n      color: #ef4444;\n    }\n  }\n\n  // Enhanced card styling with AppHeader inspiration\n  .card {\n    border: none;\n    border-radius: 16px;\n    transition: all 0.3s ease;\n    overflow: visible;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;\n    }\n\n    &.selection-card {\n      backdrop-filter: blur(20px);\n      background: rgba(255, 255, 255, 0.95);\n      border: 1px solid rgba(102, 126, 234, 0.1);\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(33, 37, 41, 0.95);\n        border-color: rgba(102, 126, 234, 0.2);\n      }\n    }\n\n    &.details-card {\n      background: rgba(255, 255, 255, 0.98);\n      backdrop-filter: blur(20px);\n      border: 1px solid rgba(102, 126, 234, 0.1);\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(33, 37, 41, 0.98);\n      }\n    }\n\n    .card-header {\n      border-radius: 16px 16px 0 0 !important;\n      padding: 1.5rem 2rem;\n      border-bottom: none;\n      position: relative;\n\n      &.gradient-header {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n        color: white !important;\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: -1px;\n          left: 0;\n          right: 0;\n          height: 1px;\n          background: linear-gradient(90deg,\n              transparent 0%,\n              rgba(255, 255, 255, 0.3) 50%,\n              transparent 100%);\n        }\n\n        h5 {\n          margin: 0;\n          font-weight: 600;\n          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n        }\n      }\n\n      &.details-header {\n        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n        color: #374151;\n        border-bottom: 1px solid rgba(102, 126, 234, 0.1);\n\n        .details-header-content {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n        }\n\n        .details-title {\n          font-weight: 600;\n          color: #667eea;\n          margin-bottom: 0.5rem;\n\n          i {\n            color: #764ba2;\n          }\n        }\n\n        .details-badges {\n          display: flex;\n          gap: 0.75rem;\n          flex-wrap: wrap;\n        }\n      }\n    }\n\n    .card-body {\n      border-radius: 0 0 16px 16px;\n      padding: 2rem;\n    }\n  }\n\n  // Action buttons styling\n  .action-buttons-group {\n    display: flex;\n    gap: 12px;\n    width: 100%;\n\n    .btn-report-generate {\n      flex: 1;\n      padding: 12px 24px;\n      font-weight: 600;\n      border-radius: 12px;\n      font-size: 0.95rem;\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      border: none;\n      color: white;\n      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n      transition: all 0.3s ease;\n\n      &:hover:not(:disabled) {\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);\n        background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n      }\n\n      i {\n        margin-right: 8px;\n      }\n    }\n\n    .btn-clear {\n      padding: 12px 20px;\n      font-weight: 600;\n      border-radius: 12px;\n      font-size: 0.95rem;\n      background: transparent;\n      border: 2px solid #e5e7eb;\n      color: #6b7280;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n\n      &:hover:not(:disabled) {\n        border-color: #ef4444;\n        color: #ef4444;\n        background: rgba(239, 68, 68, 0.05);\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n\n      .clear-icon {\n        font-size: 1.2rem;\n        font-weight: 700;\n        line-height: 1;\n      }\n    }\n  }\n\n  .action-buttons-export {\n    display: flex;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n\n    .btn-action-print,\n    .btn-action-excel {\n      border-radius: 10px;\n      padding: 8px 16px;\n      font-weight: 500;\n      transition: all 0.3s ease;\n      position: relative;\n      overflow: hidden;\n      border: 2px solid transparent;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 0;\n        height: 0;\n        background: rgba(255, 255, 255, 0.2);\n        border-radius: 50%;\n        transform: translate(-50%, -50%);\n        transition: all 0.5s ease;\n      }\n\n      &:hover::before {\n        width: 200px;\n        height: 200px;\n      }\n\n      .btn-text {\n        position: relative;\n        z-index: 2;\n      }\n\n      i {\n        position: relative;\n        z-index: 2;\n      }\n    }\n\n    .btn-action-print {\n      background: rgba(108, 117, 125, 0.1);\n      border-color: rgba(108, 117, 125, 0.2);\n      color: #6c757d;\n\n      &:hover {\n        background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);\n        border-color: #6c757d;\n        color: white;\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(108, 117, 125, 0.4);\n      }\n    }\n\n    .btn-action-excel {\n      background: rgba(25, 135, 84, 0.1);\n      border-color: rgba(25, 135, 84, 0.2);\n      color: #198754;\n\n      &:hover {\n        background: linear-gradient(135deg, #198754 0%, #157347 100%);\n        border-color: #198754;\n        color: white;\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(25, 135, 84, 0.4);\n      }\n    }\n  }\n\n  // Badge enhancements\n  .detail-badge {\n    font-weight: 500;\n    border-radius: 8px;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.875rem;\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n\n    &:hover {\n      transform: scale(1.05);\n    }\n\n    &.code-badge {\n      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n      color: white;\n      border-color: #f093fb;\n    }\n\n    &.type-badge {\n      background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n      color: white;\n      border-color: #4facfe;\n    }\n\n    &.date-badge {\n      background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n      color: white;\n      border-color: #43e97b;\n    }\n  }\n\n  // Alert styling\n  .alert {\n    border: none;\n    border-radius: 12px;\n    padding: 1rem 1.25rem;\n    backdrop-filter: blur(10px);\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n    &.alert-danger {\n      background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n      color: #dc2626;\n      border-left: 4px solid #dc3545;\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(220, 53, 69, 0.15);\n        color: #f8d7da;\n      }\n    }\n\n    i {\n      margin-right: 0.5rem;\n      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));\n    }\n  }\n\n  // CaglikReport-specific: landscape preview - full display without scrollbar\n  .report-a4-preview {\n    display: block;\n    overflow-x: auto;\n    overflow-y: visible;\n    padding: 1.5rem;\n    background: #ffffff;\n    max-height: none;\n\n    >* {\n      width: 100%;\n      min-width: 100%;\n      min-height: auto !important;\n      height: auto !important;\n    }\n  }\n\n  .report-preview-card .report-a4-preview {\n    padding: 1.5rem;\n    background: #ffffff;\n\n    >* {\n      min-height: auto !important;\n      height: auto !important;\n      padding: 0 !important;\n    }\n  }\n\n  // Multi-page visual separation in preview\n  .report-page-break {\n    margin-top: 2rem;\n    padding-top: 2rem;\n    border-top: 3px dashed #ccc;\n  }\n}\n\n// A4 Preview Styling - default (used by other reports too)\n.report-a4-preview {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  padding: 2rem;\n  border-radius: 16px;\n\n  >* {\n    width: 210mm;\n    min-height: 297mm;\n    margin: 0 auto;\n    background: white;\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.05),\n      0 20px 40px rgba(0, 0, 0, 0.1),\n      0 4px 8px rgba(0, 0, 0, 0.05);\n    padding: 12mm;\n    border-radius: 8px;\n    position: relative;\n\n    // Clean professional look without colored borders\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 2px;\n      background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n      border-radius: 8px 8px 0 0;\n      opacity: 0.3;\n    }\n  }\n}\n\n// Report preview card\n.report-preview-card {\n  border: none !important;\n  border-radius: 16px !important;\n  overflow: visible;\n  background: #ffffff;\n  backdrop-filter: blur(20px);\n\n  .card-body {\n    padding: 0 !important;\n    overflow: visible;\n  }\n\n  .report-wrap {\n    width: 100%;\n  }\n\n  .page-meta-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 8px;\n  }\n\n  .page-meta-left {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    min-height: 34px;\n  }\n\n  .page-meta-spacer {\n    width: 1px;\n    height: 1px;\n  }\n\n  .tip-code-box {\n    display: inline-flex;\n    align-items: center;\n    border: 2px solid #000;\n    background: #fff;\n    min-height: 34px;\n\n    .tip-label {\n      font-weight: 700;\n      background: #f0f0f0;\n      border-right: 2px solid #000;\n      padding: 8px 10px;\n      white-space: nowrap;\n      color: #000;\n      font-size: 13px;\n      line-height: 1;\n    }\n\n    .tip-value {\n      font-weight: 600;\n      padding: 8px 12px;\n      min-width: 120px;\n      color: #000;\n      font-size: 13px;\n      line-height: 1;\n    }\n  }\n\n  .page-number-box {\n    margin-left: auto;\n    border: 2px solid #000;\n    background: #fff;\n    color: #000;\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1;\n    white-space: nowrap;\n    padding: 7px 12px;\n  }\n\n  // Header table styles for preview\n  .header-table {\n    width: 100% !important;\n    border-collapse: collapse;\n    font-size: 14px;\n    margin-bottom: 8px;\n    border: 2px solid #000;\n    table-layout: fixed;\n\n    td {\n      border: 1px solid #000;\n      padding: 6px 10px;\n      vertical-align: middle;\n    }\n\n    .label-cell {\n      font-weight: 700;\n      background: #f5f5f5;\n      white-space: nowrap;\n      color: #000;\n    }\n\n    .value-cell {\n      background: #ffffff;\n      color: #000;\n    }\n\n    .photo-area {\n      text-align: center;\n      vertical-align: middle;\n      background: #ffffff;\n      padding: 8px 10px;\n\n      .weave-photo {\n        max-height: 110px;\n        max-width: 100%;\n        object-fit: contain;\n        display: block;\n        margin: 0 auto;\n      }\n\n      .weave-photo-placeholder {\n        font-size: 12px;\n        font-weight: 600;\n        color: #555;\n      }\n    }\n\n    .brand-area,\n    .logo-area {\n      text-align: center;\n      vertical-align: middle;\n      background: #ffffff;\n      padding: 8px 10px;\n\n      img {\n        max-height: 36px;\n        max-width: 90px;\n        object-fit: contain;\n      }\n    }\n\n    .company-name {\n      font-size: 12px;\n      font-weight: 600;\n      margin-top: 4px;\n      color: #000;\n    }\n\n    .report-main-title {\n      font-size: 14px;\n      font-weight: 700;\n      margin-top: 4px;\n      color: #000;\n    }\n  }\n\n  // Color report tables inside preview\n  .color-report-section {\n    margin: 12px 0;\n  }\n\n  .color-report-title {\n    font-size: 15px;\n    font-weight: 700;\n    padding: 6px 10px;\n  }\n\n  .color-report-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n    table-layout: fixed;\n    border: 2px solid #000;\n\n    th,\n    td {\n      border: 1px solid #000;\n      padding: 4px 6px;\n      text-align: center;\n      background: #ffffff;\n      white-space: nowrap;\n    }\n\n    th {\n      background: #f0f0f0;\n      font-weight: 600;\n      color: #000;\n    }\n\n    .yarn-name {\n      font-size: 13px !important;\n      white-space: normal !important;\n      overflow-wrap: anywhere;\n      word-break: break-word;\n    }\n\n    .yarn-code {\n      font-size: 13px !important;\n    }\n\n    .color-name {\n      font-size: 13px !important;\n      white-space: normal !important;\n      overflow-wrap: anywhere;\n      word-break: break-word;\n    }\n\n    .color-code {\n      font-size: 13px !important;\n    }\n\n    .position-col {\n      min-width: 26px;\n      font-size: 13px;\n    }\n\n    .total-col {\n      background: #e9ecef;\n      font-weight: 600;\n      font-size: 13px;\n    }\n\n    .percentage-col {\n      background: #e9ecef;\n      font-weight: 600;\n      font-size: 13px;\n    }\n\n    .weight-col {\n      background: #e9ecef;\n      font-size: 13px !important;\n    }\n  }\n\n  .report-a4-preview {\n    background: #ffffff;\n    padding: 1.5rem;\n    border-radius: 0 0 16px 16px;\n    overflow-x: auto;\n\n    >* {\n      box-shadow: none;\n      border-radius: 0;\n      min-height: auto !important;\n      height: auto !important;\n      width: 100% !important;\n      padding: 0 !important;\n      margin: 0 !important;\n\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  // Second page photo layout in preview: left fabric, right armure\n  .photo-page-section {\n    border: none;\n    padding: 0;\n    background: #fff;\n    min-height: 680px;\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .photo-page-left {\n    width: 28%;\n    max-width: 28%;\n    min-height: 680px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .photo-page-right {\n    width: 72%;\n    max-width: 72%;\n    min-height: 680px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n  }\n\n  .photo-page-frame {\n    border: none;\n    min-height: 680px;\n    width: 100%;\n    max-width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    background: #fff;\n  }\n\n  .report-photo-large {\n    width: 100%;\n    max-width: 100%;\n    max-height: 680px;\n    object-fit: contain;\n    display: block;\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .caglik-report {\n    .container-fluid {\n      padding: 0 1rem;\n    }\n\n    .page-header {\n      .page-title {\n        font-size: 1.5rem;\n        flex-direction: column;\n        align-items: flex-start;\n\n        i {\n          margin-bottom: 0.25rem;\n          margin-right: 0;\n        }\n      }\n    }\n\n    .action-buttons-group {\n      flex-direction: column;\n\n      .btn-report-generate {\n        width: 100%;\n        margin-bottom: 0.5rem;\n      }\n\n      .btn-clear {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n\n    .action-buttons-export {\n      flex-direction: column;\n      width: 100%;\n\n      .btn-action-print,\n      .btn-action-excel {\n        width: 100%;\n        justify-content: center;\n      }\n    }\n\n    .details-header-content {\n      flex-direction: column !important;\n      align-items: flex-start !important;\n      gap: 1rem;\n    }\n\n    .details-badges {\n      width: 100%;\n    }\n\n    .action-buttons-export {\n      width: 100%;\n    }\n\n    .report-a4-preview {\n      padding: 1rem;\n\n      >* {\n        width: 100%;\n        min-height: auto;\n        padding: 8mm;\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .caglik-report {\n    .details-badges {\n      .detail-badge {\n        font-size: 0.75rem;\n        padding: 0.375rem 0.625rem;\n      }\n    }\n\n    .action-buttons-export {\n\n      .btn-action-print,\n      .btn-action-excel {\n        .btn-text {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .caglik-report {\n\n    .page-header,\n    .card:not(.report-preview-card),\n    .alert {\n      display: none !important;\n    }\n  }\n\n  .report-a4-preview {\n    padding: 0 !important;\n    background: none !important;\n    border-radius: 0 !important;\n    min-height: auto !important;\n\n    >* {\n      width: 100% !important;\n      min-height: auto !important;\n      box-shadow: none !important;\n      margin: 0 !important;\n      padding: 5mm !important;\n      border-radius: 0 !important;\n      transform: none !important;\n\n      &::before {\n        display: none !important;\n      }\n    }\n  }\n}\n\n// Loading states\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// Animation enhancements\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%);\n  }\n\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.report-preview-card {\n  animation: slideInUp 0.5s ease-out;\n}\n\n// Focus states for accessibility\n.btn:focus,\n.form-control:focus,\n.form-select:focus {\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15) !important;\n  border-color: #667eea !important;\n  outline: none;\n}\n\n// Hover effects for interactive elements\n.card:hover .details-header {\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%) !important;\n}\n\n.detail-badge:hover {\n  transform: scale(1.05);\n  transition: transform 0.2s ease;\n}\n\n// Dark mode support\n[data-coreui-theme=\"dark\"] {\n  .caglik-report {\n    .page-title {\n      color: #8da3f0;\n    }\n\n    .page-subtitle {\n      color: #9ca3af;\n    }\n\n    .report-a4-preview {\n      background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n    }\n\n    .selection-card,\n    .details-card {\n      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;\n    }\n  }\n}\n\n// Scoped dark mode readability fixes (page-only)\n[data-coreui-theme=\"dark\"] .caglik-report {\n  // Base text color\n  color: #e5e7eb;\n\n  // Labels and helper text\n  .form-label-required,\n  .page-subtitle,\n  label,\n  small {\n    color: #e5e7eb;\n  }\n\n  // Cards\n  .card.selection-card,\n  .card.details-card {\n    background: rgba(17, 24, 39, 0.95);\n    color: #e5e7eb;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  // Details header contrast\n  .details-card .details-header {\n    background: linear-gradient(135deg, #111827 0%, #1f2937 100%) !important;\n    color: #e5e7eb;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  // Inputs / selects within this page\n  input.form-control,\n  .form-select {\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: #374151 !important;\n  }\n\n  input.form-control::placeholder {\n    color: #9ca3af;\n  }\n\n  // Alerts\n  .alert.alert-danger {\n    background: rgba(185, 28, 28, 0.15);\n    color: #fecaca;\n    border-left: 4px solid #ef4444;\n  }\n\n  // Buttons\n  .btn-report-generate {\n    color: #ffffff;\n  }\n\n  .btn-clear {\n    color: #9ca3af;\n    border-color: #374151;\n  }\n\n  .btn-clear:hover {\n    color: #f87171;\n    border-color: #ef4444;\n  }\n}\n\n// Utility classes\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.glassmorphism {\n  backdrop-filter: blur(20px);\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.fade-in-up {\n  animation: fadeInUp 0.5s ease forwards;\n}\n\n// Color report table styles\n.color-report-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 1rem 0;\n\n  th,\n  td {\n    border: 1px solid #dee2e6;\n    padding: 0.5rem;\n    text-align: center;\n    font-size: 0.875rem;\n  }\n\n  th {\n    background: #f8f9fa;\n    font-weight: 600;\n    color: #495057;\n  }\n\n  .color-name {\n    width: 150px;\n    text-align: left;\n    font-weight: 500;\n  }\n\n  .color-number {\n    width: 120px;\n    text-align: left;\n    font-weight: 500;\n  }\n\n  .position-col {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .total-col {\n    width: 80px;\n    text-align: center;\n    font-weight: 600;\n    background: #e9ecef;\n  }\n\n  .percentage-col {\n    width: 60px;\n    text-align: center;\n    font-weight: 600;\n  }\n\n  .weight-col {\n    width: 80px;\n    text-align: center;\n    font-weight: 500;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
